export enum MatchCardActionType  {
  SetIsExpanded = 'SET_IS_EXPANDED',
}
